import React, { useState } from 'react';
import './_activateMonestoCard.less';
import { MonestoLogo } from 'IMAGE';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';

const ActivateMonestoCard = ({ activateAccess, firstLoginMonesto, isSpecialUser }) => {
  const [visible, setVisible] = useState(false);

  const handleButtonClick = () => {
    if (isSpecialUser) {
      activateAccess('monesto');
    } else {
      setVisible(true);
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleConfirm = () => {
    setVisible(false);
    activateAccess('monesto');
  };

  return (
    <>
      <Modal
        visible={visible}
        destroyOnClose={true}
        maskClosable={false}
        title='Activate Monesto'
        footer={null}
        onCancel={handleCancel}
      >
        <div className='modal-description'>
          <p>Once your Monesto account is activated, your Magma account will be closed.</p>
          <p>
            By clicking Continue, you confirm that you understand and agree that any available balance in your Magma
            wallet will be transferred to your Monesto wallet.
          </p>
          <p>If you have any questions before proceeding, please contact your personal manager.</p>
        </div>
        <div className='modal-footer'>
          <Button htmlType='submit' type={'dashed'} size={'large'} onClick={handleCancel} block>
            CANCEL
          </Button>
          <Button htmlType='submit' type={'primary'} size={'large'} onClick={handleConfirm} block>
            CONTINUE
          </Button>
        </div>
      </Modal>

      <div className='card-dashboard-monesto'>
        <div className='card-dashboard-monesto__content'>
          <div className='title'>
            <MonestoLogo />
          </div>

          <div className='description'>Trusted Payment Partner for Complex Businesses</div>
          <div className='text'>
            Partner with a provider that understands your industry. Get efficient payment solutions tailored to your
            needs
          </div>

          <Button htmlType='submit' type={'dashed'} size={'large'} onClick={handleButtonClick} block>
            {firstLoginMonesto ? 'Activate access' : 'Re-Login'}
          </Button>
        </div>
      </div>
    </>
  );
};

export default ActivateMonestoCard;

ActivateMonestoCard.propTypes = {
  activateAccess: PropTypes.func.isRequired,
  firstLoginMonesto: PropTypes.bool,
  isSpecialUser: PropTypes.bool,
};
